import { render, staticRenderFns } from "./DemoSocket.vue?vue&type=template&id=fa667e88"
import script from "./DemoSocket.vue?vue&type=script&lang=ts"
export * from "./DemoSocket.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VSheet})
